import isEmpty from "validator/lib/isEmpty";
import isEmail from "validator/lib/isEmail";
import isLength from "validator/lib/isLength";
import isObject from "lodash.isobject";

export const validateLines = ({
  line1Part1,
  line1Part2,
  line2Part1,
  line2Part2,
}) => {
  let errors = {};
  if ([line1Part1, line1Part2, line2Part1, line2Part2].every((item) => !item)) {
    // TODO: change validation message
    console.log("TODO validation message ID4");
    errors.form = "Please fill in the inputs.";
  }

  return errors;
};

export const validateQty = (qty, errorKey = "qty", minValue = 1) => {
  let errors = {};
  if (!Number.isInteger(qty) || qty < minValue) {
    // TODO: replace err message
    console.log("TODO validation message ID5");
    errors = {
      [errorKey]: `The quantity value should be integer greater than ${minValue}`,
    };
  } else {
    errors = {
      [errorKey]: undefined,
    };
  }
  return errors;
};

export const validateRequired = (value) => {
  if (isEmpty(value)) {
    return "Påkrævet";
  }
  return false;
};

export const validateEmail = (value) => {
  if (!isEmpty(value) && !isEmail(value)) {
    return "Forkert email";
  }

  return false;
};

export function validateForLength({ values, errors, maxLength }) {
  Object.entries(values).forEach(([key, fieldValue = ""]) => {
    if (isObject(fieldValue)) {
      validateForLength({ values: fieldValue, errors, maxLength });
    }

    if (typeof fieldValue === "string") {
      const errMsg = validateInputLength(fieldValue, maxLength);
      if (errMsg) {
        errors[key] = errMsg;
      }
    }
  });
}

function validateInputLength(inputValue, maxLength = 100) {
  if (!isLength(inputValue, { max: maxLength })) {
    return `Must be no more than ${maxLength} characters.`;
  }
}
